import type AjaxService from 'garaje/services/ajax';

export type ChangeReevaluationStrategy = 'reevaluate' | 'skip';

// VIS-17085: per-policy skip-re-evaluation config for ad hoc invite fields. Mirrors the
// workflow-task-adapter policy-draft shape; `skip` means a change to that component does
// not re-fire the approval.
export interface ChangeHandling {
  arrivalDate: ChangeReevaluationStrategy;
  arrivalTime: ChangeReevaluationStrategy;
}

export interface PolicyDraftResponse {
  automaticReevaluation: boolean;
  // Optional — already present in the WTA response; absent for pre-VIS-17085 drafts.
  changeHandling?: ChangeHandling;
}

export async function fetchPolicyDraft(ajax: AjaxService, inviteId: string): Promise<PolicyDraftResponse> {
  return ajax.request<PolicyDraftResponse>(`/a/visits/api/v1/workflows/invite/${inviteId}/policy-draft`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
}
